export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    slug: 'skin-care',
    name: '肌肤护理',
    description: '为妈妈量身定制的科学护肤方案，从清洁、保湿到抗老，每一步都精心呵护',
    icon: 'ri-drop-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20skincare%20products%20with%20rose%20petals%20and%20soft%20natural%20light%20on%20a%20warm%20cream%20marble%20surface%2C%20minimalist%20aesthetic%2C%20soft%20feminine%20tones%2C%20editorial%20beauty%20photography%20with%20gentle%20shadows%20and%20delicate%20composition&width=600&height=450&seq=cat-skin-care&orientation=landscape',
  },
  {
    slug: 'image-enhance',
    name: '形象提升',
    description: '从穿搭到气质，全方位提升妈妈的整体形象，让自信由内而外绽放',
    icon: 'ri-shining-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stylish%20modern%20mother%20in%20elegant%20casual%20outfit%20standing%20in%20a%20bright%20airy%20room%20with%20warm%20cream%20walls%2C%20confident%20pose%2C%20soft%20natural%20lighting%2C%20lifestyle%20fashion%20photography%20with%20gentle%20warm%20tones%20and%20sophisticated%20composition&width=600&height=450&seq=cat-image-enhance&orientation=landscape',
  },
  {
    slug: 'beauty-secrets',
    name: '美丽秘籍',
    description: '分享实用美丽的保养小技巧和生活智慧，让美丽成为妈妈日常生活的一部分',
    icon: 'ri-book-open-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20beautiful%20journal%20and%20fresh%20flowers%20on%20a%20warm%20wooden%20desk%20with%20soft%20morning%20sunlight%20streaming%20through%20a%20window%2C%20cozy%20atmosphere%2C%20cream%20and%20blush%20color%20palette%2C%20lifestyle%20photography%20with%20gentle%20shadows%20and%20dreamy%20composition&width=600&height=450&seq=cat-beauty-secrets&orientation=landscape',
  },
  {
    slug: 'mom-stories',
    name: '妈妈故事',
    description: '聆听真实妈妈的美丽蜕变经历，在这里找到共鸣、汲取力量',
    icon: 'ri-heart-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20and%20gentle%20portrait%20of%20a%20smiling%20mother%20with%20her%20child%20in%20a%20sunlit%20garden%2C%20soft%20natural%20light%2C%20cream%20and%20blush%20tones%2C%20emotional%20lifestyle%20photography%20with%20shallow%20depth%20of%20field%20and%20tender%20composition&width=600&height=450&seq=cat-mom-stories&orientation=landscape',
  },
];